
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';

/**
 * SocialTradingMasterAccountToRegularResponse struct
 */
class SocialTradingMasterAccountToRegularResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!number=} exMasterLogin
   * @param {!Array=} exInvestorLogins
   * @constructor
   */
  constructor (parent = new Response(), exMasterLogin = new UInt64(0, 0), exInvestorLogins = []) {
    super()
    super.copy(parent)
    this.ExMasterLogin = exMasterLogin
    this.ExInvestorLogins = exInvestorLogins
  }

  /**
   * Copy struct (shallow copy)
   * @this {!SocialTradingMasterAccountToRegularResponse}
   * @param {!SocialTradingMasterAccountToRegularResponse} other Other struct
   * @returns {!SocialTradingMasterAccountToRegularResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.ExMasterLogin != null) {
      this.ExMasterLogin = UInt64.fromNumber(other.ExMasterLogin)
    } else {
      this.ExMasterLogin = null
    }
    if (other.ExInvestorLogins != null) {
      this.ExInvestorLogins = []
      for (let item of other.ExInvestorLogins) {
        if (item != null) {
          let tempItem
          tempItem = UInt64.fromNumber(item)
          this.ExInvestorLogins.push(tempItem)
        } else {
          this.ExInvestorLogins.push(null)
        }
      }
    } else {
      this.ExInvestorLogins = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!SocialTradingMasterAccountToRegularResponse}
   * @returns {!SocialTradingMasterAccountToRegularResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new SocialTradingMasterAccountToRegularResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new SocialTradingMasterAccountToRegularResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!SocialTradingMasterAccountToRegularResponse}
   * @param {!SocialTradingMasterAccountToRegularResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof SocialTradingMasterAccountToRegularResponse)) {
      throw new TypeError('Instance of SocialTradingMasterAccountToRegularResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!SocialTradingMasterAccountToRegularResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      ExMasterLogin: ((this.ExMasterLogin != null) ? this.ExMasterLogin.toNumber() : null),
      ExInvestorLogins: ((this.ExInvestorLogins != null) ? Array.from(this.ExInvestorLogins, item => ((item != null) ? item.toNumber() : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return SocialTradingMasterAccountToRegularResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!SocialTradingMasterAccountToRegularResponse} other Object value
   * @returns {!SocialTradingMasterAccountToRegularResponse} Created struct
   */
  static fromObject (other) {
    return new SocialTradingMasterAccountToRegularResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!SocialTradingMasterAccountToRegularResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return SocialTradingMasterAccountToRegularResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!SocialTradingMasterAccountToRegularResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6487
  }
}

export { SocialTradingMasterAccountToRegularResponse };

/**
 * Fast Binary Encoding SocialTradingMasterAccountToRegularResponse field model
 */
class FieldModelSocialTradingMasterAccountToRegularResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.ExMasterLogin = new fbe.FieldModelUInt64(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.ExInvestorLogins = new fbe.FieldModelVector(new fbe.FieldModelUInt64(buffer, this.ExMasterLogin.fbeOffset + this.ExMasterLogin.fbeSize), buffer, this.ExMasterLogin.fbeOffset + this.ExMasterLogin.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.ExMasterLogin.fbeSize + this.ExInvestorLogins.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.ExMasterLogin.fbeExtra + this.ExInvestorLogins.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelSocialTradingMasterAccountToRegularResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6487
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ExMasterLogin.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExMasterLogin.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExMasterLogin.fbeSize

    if ((fbeCurrentSize + this.ExInvestorLogins.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ExInvestorLogins.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExInvestorLogins.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @param {!SocialTradingMasterAccountToRegularResponse} fbeValue Default value, defaults is new SocialTradingMasterAccountToRegularResponse()
   * @returns {!SocialTradingMasterAccountToRegularResponse} SocialTradingMasterAccountToRegularResponse value
   */
  get (fbeValue = new SocialTradingMasterAccountToRegularResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @param {!SocialTradingMasterAccountToRegularResponse} fbeValue SocialTradingMasterAccountToRegularResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ExMasterLogin.fbeSize) <= fbeStructSize) {
      fbeValue.ExMasterLogin = this.ExMasterLogin.get()
    } else {
      fbeValue.ExMasterLogin = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExMasterLogin.fbeSize

    if ((fbeCurrentSize + this.ExInvestorLogins.fbeSize) <= fbeStructSize) {
      this.ExInvestorLogins.get(fbeValue.ExInvestorLogins)
    } else {
      fbeValue.ExInvestorLogins.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ExInvestorLogins.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @param {!SocialTradingMasterAccountToRegularResponse} fbeValue SocialTradingMasterAccountToRegularResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelSocialTradingMasterAccountToRegularResponse}
   * @param {SocialTradingMasterAccountToRegularResponse} fbeValue SocialTradingMasterAccountToRegularResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.ExMasterLogin.set(fbeValue.ExMasterLogin)
    this.ExInvestorLogins.set(fbeValue.ExInvestorLogins)
  }
}

export { FieldModelSocialTradingMasterAccountToRegularResponse };

/**
 * Fast Binary Encoding SocialTradingMasterAccountToRegularResponse model
 */
class SocialTradingMasterAccountToRegularResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelSocialTradingMasterAccountToRegularResponse(this.buffer, 4)
  }

  /**
   * Get the SocialTradingMasterAccountToRegularResponse model
   * @this {!SocialTradingMasterAccountToRegularResponseModel}
   * @returns {!FieldModelSocialTradingMasterAccountToRegularResponse} model SocialTradingMasterAccountToRegularResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!SocialTradingMasterAccountToRegularResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!SocialTradingMasterAccountToRegularResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return SocialTradingMasterAccountToRegularResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!SocialTradingMasterAccountToRegularResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelSocialTradingMasterAccountToRegularResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!SocialTradingMasterAccountToRegularResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!SocialTradingMasterAccountToRegularResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!SocialTradingMasterAccountToRegularResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!SocialTradingMasterAccountToRegularResponseModel}
   * @param {!SocialTradingMasterAccountToRegularResponse} value SocialTradingMasterAccountToRegularResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!SocialTradingMasterAccountToRegularResponseModel}
   * @param {!SocialTradingMasterAccountToRegularResponse} value SocialTradingMasterAccountToRegularResponse value, defaults is new SocialTradingMasterAccountToRegularResponse()
   * @return {!object} Deserialized SocialTradingMasterAccountToRegularResponse value and its size
   */
  deserialize (value = new SocialTradingMasterAccountToRegularResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new SocialTradingMasterAccountToRegularResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new SocialTradingMasterAccountToRegularResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!SocialTradingMasterAccountToRegularResponseModel}
   * @param {!number} prev Previous SocialTradingMasterAccountToRegularResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { SocialTradingMasterAccountToRegularResponseModel };
